export default "__VITE_ASSET__BRjGu1H4__"